import { ArrowLeftIcon, XIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import TinyMce from "components/GbCpn/TinyMce";
import SidebarLayout from "components/Layout/Layout";
import { useEffect, useRef, useState } from "react";
import { DetailProductGuildDocument, DetailProductGuildVideo } from "./type";
import StoreProductCard from "./component/productsCard";
import { useSearchParams } from "react-router-dom";
import ProductDetailPlatformInfo from "./component/detailPlatformDetail";
import BuyProductPopUp from "./component/buyProductPopUp";
import { Breadcrumb, Tabs, Modal } from 'antd';
import type { TabsProps } from 'antd';
import DetailProductFeature from "./component/detailFeatureTab";
import DetailGuildTab from "./component/detailGuildTab";
import DetailProductInfo from "./component/detailProductInfo";
import { toast } from "react-toastify";
import { API_URL } from "env";

const language_options = [
    { lable: 'English', value: 'en' },
    { lable: 'Vietnamese', value: 'vi' },
    // { lable: 'Japanese', value: 'jp' },
    // { lable: 'Chinese', value: 'cn' },
    // { lable: 'Korean', value: 'kr' },
    // { lable: 'French', value: 'fr' },
    // { lable: 'German', value: 'de' },
    // { lable: 'Vietnamese', value: 'vi' },
]

const platform_options = [
    { lable: 'All Platform', value: 'all' },
    { lable: 'MetaTrader 4', value: 'MT4' },
    { lable: 'MetaTrader 5', value: 'MT5' },
    { lable: 'cTrader', value: 'cTrader' },
]

const indicator_list = [
    { lable: 'Hot', value: 'Hot' },
    { lable: 'New', value: 'New' },
    { lable: 'Sale', value: 'Sale' },
    { lable: 'Popular', value: 'Popular' },
]

const StoreItems = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const type = searchParams.get('type');
    const id = searchParams.get('id');
    const [ViewState, setViewState] = useState<'add' | 'edit' | 'review'>('add');
    useEffect(() => {
        if (type === 'add' || type === 'edit' || type === 'review') {
            setViewState(type);
        } else {
            setViewState('add');
        }
    }, [type]);
    // Internal states
    const [imagesFile, setImagesFile] = useState<File | null>(null);
    const [imagesSrc, setImagesSrc] = useState<string>('');
    const [itemsFile, setItemsFile] = useState<File | null>(null);

    const [itemsName, setItemsName] = useState<string>('');
    const [itemsPlatform, setItemsPlatform] = useState<string>('');
    const [enabledItemIndicator, setEnabledItemIndicator] = useState<boolean>(false);
    const [itemsIndicator, setItemsIndicator] = useState<string>('');
    const [itemsDescription, setItemsDescription] = useState<{ en: string; vi: string }>({
        en: '',
        vi: '',
    });
    const [price, setPrice] = useState<string>('');
    const [discount, setDiscount] = useState<string>('');
    const [finalPrice, setFinalPrice] = useState<string>('');

    const [mainFeature, setMainFeature] = useState<{ en: string[]; vi: string[] }>({
        en: [],
        vi: [],
    });
    const [selectedLanguage, setSelectLanguage] = useState<string>('en');
    const [detail, setDetail] = useState({
        en: '',
        vi: '',
    })

    const [document, setDocument] = useState<DetailProductGuildDocument>({
        totalPages: 0,
        url: '',
        option: [],
        language: [],
    });
    const [documentHasValue, setDocumentHasValue] = useState<{en:boolean;vi:boolean}>(
        { en: false, vi: false }
    );
    const [documentFile, setDocumentFile] = useState<{ en: File | null, vi: File | null }>(
        { en: null, vi: null }
    );
    const [video, setVideo] = useState<DetailProductGuildVideo>({
        duration: '',
        url: '',
        difficulty: '',
        language: [],
    });


    // Handle file changes

    const handleImagesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setImagesFile(file);
            setImagesSrc(URL.createObjectURL(file));
        }
    }
    const handleItemsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setItemsFile(file);
        }
    }

    // Ref
    const pageRef = useRef<HTMLDivElement>(null);

    // Function

    function convertFileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.result) {
                    resolve(reader.result.toString());
                } else {
                    reject('Failed to convert file or image to base64');
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    }

    const convertZipToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.result) {
                    resolve(reader.result.toString());
                } else {
                    reject('Failed to convert zip to base64');
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const convertBase64ToFile = (base64String: string, filename: string, mimeType: string): File => {
        const byteString = atob(base64String.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new File([ab], filename, { type: mimeType });
    };

    function checkValidData() {
        if (ViewState === 'add' && !imagesFile) {
            toast.error('Please upload banner image');
            return false;
        }
        if (ViewState === 'add' && !itemsFile) {
            toast.error('Please upload items file');
            return false;
        }
        if (!itemsName) {
            toast.error('Please enter store name');
            return false;
        }
        if (!itemsPlatform) {
            toast.error('Please select platform');
            return false;
        }
        if (enabledItemIndicator && !itemsIndicator) {
            toast.error('Please select indicator');
            return false;
        }
        if (!itemsDescription.en && !itemsDescription.vi) {
            toast.error('Please enter subTitle/short description');
            return false;
        }
        // if (!price) {
        //     toast.error('Please enter price');
        //     return false;
        // }
        // if (isNaN(parseFloat(price))) {
        //     toast.error('Price must be a number');
        //     return false;
        // }
        // if (discount && isNaN(parseFloat(discount))) {
        //     toast.error('Discount must be a number');
        //     return false;
        // }
        // if (discount && parseFloat(discount) >= 100) {
        //     toast.error('Discount must be less than 100%');
        //     return false;
        // }
        if (mainFeature.en.length === 0 && mainFeature.vi.length === 0 ) {
            toast.error('Please enter main feature');
            return false;
        }
        if (!detail.en && !detail.vi) {
            toast.error('Please enter detail info');
            return false;
        }
        if (video.url) {
            if (!video.duration) {
                toast.error('Please enter video duration');
                return false;
            }
            if (video.language.length === 0) {
                toast.error('Please enter video language');
                return false;
            }
        }
        if (ViewState === 'add') {
            if (!documentFile.en) {
                toast.error('Please upload document file');
                return false;
            }
            if (document.totalPages <= 0) {
                toast.error('Please enter document total pages');
                return false;
            }
        }
        return true;
    }

    function handleSubmitData() {
        if (!checkValidData()) return;
        // Handle submit data to backend here
        SubmitData();
    }

    async function SubmitData() {
        
        const formData = new FormData();

        if (imagesFile) formData.append('image', await convertFileToBase64(imagesFile));
        if (itemsFile) formData.append('file_bot', itemsFile);
        // Document files
        if (documentFile.en) formData.append('file_pdf_en', documentFile.en )
        if (documentFile.vi) formData.append('file_pdf_vi', documentFile.vi )
        
        // Other fields as JSON strings for nested structures
        formData.append('title', JSON.stringify({
            en: itemsName,
            vi: itemsName,
        }));
        formData.append('subtitle', JSON.stringify({
            en: itemsDescription.en,
            vi: itemsDescription.vi,
        }));
        formData.append('description', JSON.stringify({
            en: detail.en,
            vi: detail.vi,
        }));
        formData.append('main_feature', JSON.stringify({
            en: mainFeature.en,
            vi: mainFeature.vi,
        }));
        formData.append('video_url', JSON.stringify({
           en: video.language.find(lang => lang.name === 'en')?.url || '',
           vi: video.language.find(lang => lang.name === 'vi')?.url || '',
        }));
        formData.append('video_duration', video.duration || '');
        formData.append('pdf_page', String(document.totalPages || 0));
        formData.append('featured', enabledItemIndicator ? '1' : '0');
        formData.append('platform', itemsPlatform || '');
        formData.append('price', String(parseFloat(price) || 0));
        formData.append('price_discount', String(parseFloat(discount) || 0));
        formData.append('price_finalize', String(parseFloat(finalPrice) || 0));
        try {
            const res = await fetch(API_URL + `api/v1/be/tools${ViewState === "edit" ? `/${id}` : ''}`, {
                method: "POST",
                headers: {
                    // Do NOT set Content-Type; browser will set the correct multipart boundary
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
                body: formData,
            });

            const result = await res.json();
            
            if (result.status) {
                toast.success('Submit data successfully! Redirecting...');
                setTimeout(() => {
                    window.location.href = '/stores';
                }, 1500);
            }
            else {
                toast.error(result.message || 'Submit data failed');
            }
        }
        catch (error) {
            console.error('Error submitting data:', error);
        }
        
        
    }


    // Preview 
    const [isBuyOpen, setIsBuyOpen] = useState(false);

    // Tabs items
    const items: TabsProps['items'] = [
        {
            key: '1',
            style: { width: '100%' },
            label: (
                <div className="flex items-center justify-center gap-2 py-1 px-16">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-zap h-5 w-5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                    Functions and Features
                </div>
            ),
            children: <DetailProductFeature
                mainFeature={mainFeature.en}
                detail={detail}
            />,
        },
        {
            key: '2',
            style: { width: '100%' },
            label: (
                <div className="flex items-center justify-center gap-2 py-1 px-16">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-text h-5 w-5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
                    User Guide
                </div>
            ),
            children: <DetailGuildTab
                video={video}
                document={document}
            />,
        },
    ];

    // Use effect
    // Calculate final price
    useEffect(() => {
        const priceNum = parseFloat(price) || 0;
        const discountNum = parseFloat(discount) || 0;
        if (priceNum && discountNum) {
            const discountedPrice = priceNum - (priceNum * (discountNum / 100));
            setFinalPrice(discountedPrice.toFixed(2));
        } else {
            setFinalPrice(price);
        }
    }, [price, discount]);

    // Get data if edit or review
    useEffect(() => {
        async function fetchData() {
            if ((ViewState === 'edit' || ViewState === 'review') && id) {
                const res = await fetch(API_URL + `api/v1/be/tools/${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                const result = await res.json();
                if (result.status) {
                    const data = result.data;
                    if (data.image) {
                        setImagesSrc(data.image_url);
                    }
                    setItemsName(data.title.en || '');
                    setItemsPlatform(data.platform || '');
                    setItemsIndicator(data.featured ? 'Hot' : '');
                    setEnabledItemIndicator(data.featured ? true : false);
                    setItemsDescription({ en: data.subtitle.en || '', vi: data.subtitle.vi || '' });
                    setPrice(data.price ? data.price.toString() : '');
                    setDiscount(data.price_discount ? data.price_discount.toString() : '');
                    setFinalPrice(data.price_finalize ? data.price_finalize.toString() : '');
                    setMainFeature({ en: data.main_feature.en || [], vi: data.main_feature.vi || [] });
                    setDetail({ en: data.description.en || '', vi: data.description.vi || '' });
                    setVideo({
                        duration: data.video_duration || '',
                        url: data.video_url.en || '',
                        difficulty: data.video_difficulty || '',
                        language: [
                            { name: 'en', icon: '', url: data.video_url.en || '' },
                            { name: 'vi', icon: '', url: data.video_url.vi || '' }
                        ],
                    })
                    setDocument({
                        totalPages: data.pdf_page || 0,
                        language: [
                            { name: 'en', icon: '', url: data.file_pdf?.en || '' },
                            { name: 'vi', icon: '', url: data.file_pdf?.vi || '' }
                        ],
                        option: [],
                        url: data.file_pdf || '',
                    })
                    setDocumentHasValue({
                        en: data.file_pdf?.en ? true : false,
                        vi: data.file_pdf?.vi ? true : false,
                    })
                } else {
                    toast.error(result.message || 'Fetch data failed');
                }
            }
        }
        fetchData();
    }, [ViewState, id]);

    if (ViewState === 'add' || ViewState === 'edit')
        return (
            <SidebarLayout
                title={
                    <div className="flex items-center gap-2 py-4">
                        <button
                            onClick={() => navigate('/stores')}
                            className="flex items-center justify-center w-7 h-7 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors cursor-pointer"
                        >
                            <ArrowLeftIcon size={16} />
                        </button>
                        <Breadcrumb
                            separator=">"
                            items={[
                                { title: <span className="cursor-pointer" onClick={() => navigate('/stores')}>Stores</span> },
                                { title: ViewState === 'add' ? 'Add New Item' : `Edit Item #${id}` },
                            ]}
                        />
                    </div>
                }
            >
                <div className="w-full px-4 py-4 bg-white rounded-lg shadow-md">
                    <div className="w-full relative h-72 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg">
                        {imagesSrc ? (
                            <>
                                <button title="clearImages" onClick={() => { setImagesFile(null); setImagesSrc(''); }
                                } className="absolute cursor-pointer top-2 right-2 bg-red-500 !text-white rounded-full p-1 hover:bg-red-600">
                                    <XIcon size={18} />
                                </button>
                                <img
                                    src={imagesFile ? URL.createObjectURL(imagesFile) : imagesSrc}
                                    alt="Uploaded"
                                    className="max-h-full max-w-full object-contain"
                                />
                            </>
                        ) : (
                            <>
                                <label
                                    htmlFor="fileInput"
                                    className="cursor-pointer text-gray-500 hover:text-gray-700 w-full h-full flex flex-col items-center justify-center"
                                >
                                    Click to upload banner image
                                </label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    accept="image/*"
                                    onChange={handleImagesChange}
                                    className="hidden"
                                />
                            </>
                        )}
                    </div>
                </div>
                {
                    ViewState === 'add' && (
                        <div className="w-full px-4 py-2 bg-white flex flex-row items-center gap-8 rounded-lg shadow-md mt-4">
                            <label className="block text-gray-700 font-semibold !mb-0" htmlFor="itemsFileInput">
                                Upload Items File (.algo ...)
                            </label>
                            {itemsFile ? (
                                <div className="flex items-center space-x-4">
                                    <span>{itemsFile.name}</span>
                                    <button title="clearItems" onClick={() => setItemsFile(null)} className="bg-red-500 !text-white rounded-full p-1 hover:bg-red-600">
                                        <XIcon size={14} />
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <label
                                        htmlFor="itemsFileInput"
                                        className="cursor-pointer text-gray-500 hover:text-gray-700"
                                    >
                                        Choose File
                                    </label>
                                    <input
                                        type="file"
                                        id="itemsFileInput"
                                        onChange={handleItemsChange}
                                        className="hidden"
                                    />
                                </>
                            )}
                        </div>
                    )
                }
                {
                    ViewState === 'edit' && (
                        <div className="w-full px-4 py-2 bg-white flex flex-row items-center gap-8 rounded-lg shadow-md mt-4">
                            <label className="block text-gray-700 font-semibold !mb-0" htmlFor="itemsFileInput">
                                Update Items File (.algo ...) (Leave blank if not change)
                            </label>
                            {itemsFile ? (
                                <div className="flex items-center space-x-4">
                                    <span>{itemsFile.name}</span>
                                    <button title="clearItems" onClick={() => setItemsFile(null)} className="bg-red-500 !text-white rounded-full p-1 hover:bg-red-600">
                                        <XIcon size={14} />
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <label
                                        htmlFor="itemsFileInput"
                                        className="cursor-pointer text-gray-500 hover:text-gray-700"
                                    >
                                        Choose File
                                    </label>
                                    <input
                                        type="file"
                                        id="itemsFileInput"
                                        onChange={handleItemsChange}
                                        className="hidden"
                                    />
                                </>
                            )}
                        </div>
                    )
                }
                <div className="w-full border-b-2 border-dashed h-4 mt-4" />
                <div className="w-full px-4 py-2 bg-white rounded-lg shadow-md mt-4">
                    <div className="flex items-start gap-2 flex-col">
                        <label className="block !text-base text-gray-700 !mb-0" htmlFor="detailLanguage">
                            Language ( effect for Description,  Main Feature and Detail Info )
                        </label>
                        <select
                            id="detailLanguage"
                            value={selectedLanguage}
                            onChange={(e) => setSelectLanguage(e.target.value)}
                            className="mb-4 w-full px-3 py-2 border border-gray-300 rounded"
                        >
                            {language_options.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.lable}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="w-full px-4 py-2 bg-white rounded-lg shadow-md mt-4">
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2" htmlFor="storeName">
                            Store Name
                        </label>
                        <input
                            type="text"
                            id="storeName"
                            onChange={(e) => setItemsName(e.target.value)}
                            value={itemsName}
                            className="w-full px-3 py-2 border border-gray-300 rounded"
                            placeholder="Enter store name"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2" htmlFor="platform">
                            Platform
                        </label>
                        <select
                            id="platform"
                            value={itemsPlatform}
                            onChange={(e) => setItemsPlatform(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded"
                        >
                            <option value="">Select Platform</option>
                            {platform_options.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.lable}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-4">
                        <div className="flex flex-row items-center gap-8 mb-2">
                            <label className="block text-gray-700 mb-0" htmlFor="indicator">
                                Indicator
                            </label>
                            <input type="checkbox" checked={enabledItemIndicator} onChange={(e) => {
                                setItemsIndicator('Hot')
                                setEnabledItemIndicator(e.target.checked)
                            }} />
                        </div>
                        <div className="flex items-center gap-4">

                            {
                                enabledItemIndicator && (
                                    <select
                                        id="indicator"
                                        value={itemsIndicator}
                                        onChange={(e) => setItemsIndicator(e.target.value)}
                                        className="w-full px-3 py-2 border border-gray-300 rounded"
                                    >
                                        {indicator_list.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.lable}
                                            </option>
                                        ))}
                                    </select>
                                )
                            }
                        </div>
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2" htmlFor="description">
                            SubTitle / Short Description 
                        </label>
                        <textarea
                            id="description"
                            onChange={(e) => setItemsDescription({ ...itemsDescription, [selectedLanguage]: e.target.value })}
                            value={itemsDescription[selectedLanguage as 'en' | 'vi']}
                            className="w-full px-3 py-2 border border-gray-300 rounded"
                            placeholder="Enter description"
                            rows={4}
                        ></textarea>
                    </div>
                </div>
                <div className="w-full px-4 py-2 bg-white rounded-lg shadow-md mt-4">
                    <div className="flex flex-row justify-between gap-4">
                        <div className="mb-4 w-full">
                            <label className="block text-gray-700 mb-2" htmlFor="price">
                                Price
                            </label>
                            <input
                                type="text"
                                id="price"
                                onChange={(e) => setPrice(e.target.value)}
                                value={price}
                                className="w-full px-3 py-2 border border-gray-300 rounded"
                                placeholder="Enter price"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-gray-700 mb-2" htmlFor="discount">
                                Discount (%)
                            </label>
                            <input
                                type="number"
                                max={100}
                                min={0}
                                id="discount"
                                onChange={(e) => setDiscount(e.target.value)}
                                value={discount}
                                className="w-full px-3 py-2 border border-gray-300 rounded"
                                placeholder="Enter discount"
                            />
                        </div>
                    </div>
                    <div className="flex justify-start">
                        Final Price:
                        <span className="text-2xl font-bold text-gray-900 ml-2">
                            {Number(finalPrice).toLocaleString('en')}
                        </span>
                    </div>
                </div>
                <div className="w-full border-b-2 border-dashed h-4" />
                <div className="w-full px-4 py-2 bg-white rounded-lg shadow-md mt-4">
                    <div className="mb-4">
                        <label className="block text-xl text-gray-700 mb-2" htmlFor="mainFeature">
                            Main Feature
                        </label>
                        {(mainFeature[selectedLanguage as 'en' | 'vi'] ?? []).map((feature: string, index: number) => (
                            <div key={index} className="flex items-center mb-2 relative">
                                <input
                                    type="text"
                                    value={feature}
                                    onChange={(e) => {
                                        const newFeatures = [...mainFeature[selectedLanguage as 'en' | 'vi']];
                                        newFeatures[index] = e.target.value;
                                        setMainFeature({
                                            ...mainFeature,
                                            [selectedLanguage]: newFeatures
                                        });
                                    }}
                                    className="w-full px-3 py-2 border border-gray-300 rounded"
                                    placeholder={`Feature ${index + 1}`}
                                />
                                <button
                                    type="button"
                                    title="Remove Feature"
                                    onClick={() => {
                                        const newFeatures = mainFeature[selectedLanguage as 'en' | 'vi'].filter((_, i) => i !== index);
                                        setMainFeature({
                                            ...mainFeature,
                                            [selectedLanguage]: newFeatures
                                        });
                                    }}
                                    className="absolute right-2 !text-red-500 rounded-full p-1 cursor-pointer hover:!bg-red-100">
                                    <XIcon size={14} />
                                </button>
                            </div>
                        ))}
                        <button
                            type="button"
                            onClick={() => setMainFeature({
                                ...mainFeature,
                                [selectedLanguage]: [
                                    ...mainFeature[selectedLanguage as 'en' | 'vi'],
                                    ''
                                ]
                            })}
                            className="border border-dashed border-gray-300 px-3 py-2 rounded hover:bg-gray-100 w-full"
                        >
                            + Add Feature
                        </button>
                    </div>
                    <div className="mb-4 flex gap-4 flex-col">
                        <div className="flex items-center flex-row gap-4">
                            <label className="block text-xl text-gray-700 mb-0" htmlFor="detail">
                                Description
                            </label>
                        </div>

                        <TinyMce
                            defaultValue={detail[selectedLanguage as 'en' | 'vi']}
                            onChange={(content) => setDetail({ ...detail, [selectedLanguage]: content })}
                        />
                    </div>
                </div>
                <div className="w-full border-b-2 border-dashed h-4" />
                <div className="w-full grid grid-cols-2 gap-2">
                    <div>
                        <h3 className="text-xl font-bold mt-2 !mb-0 text-gray-800">Document Guide</h3>
                        <div className="w-full px-4 py-2 bg-white rounded-lg shadow-md mt-2 flex flex-col gap-4">
                            {/* Document Section */}
                            {language_options.map((option, index) => (
                                <div key={option.value} className={`mb-4 ${index === language_options.length - 1 ? '' : 'border-b pb-4'}`}>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 mb-2" htmlFor={`docLanguage${option.value}`}>
                                            Document Language ({option.lable}) 
                                        </label>
                                        <input
                                            type="text"
                                            id={`docLanguage${option.value}`}
                                            value={option.lable}
                                            disabled
                                            className="w-full px-3 py-2 border border-gray-300 rounded bg-gray-100"
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 mb-2" htmlFor={`totalPages_${option.value}`}>
                                            Total Pages
                                        </label>
                                        <input
                                            type="number"
                                            id={`totalPages_${option.value}`}
                                            value={document.totalPages}
                                            onChange={(e) => setDocument({ ...document, totalPages: parseInt(e.target.value) || 0 })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded"
                                            placeholder="Enter total pages"
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 mb-2" htmlFor={`docFileInput_${option.value}`}>
                                            Document File 
                                        </label>
                                        {documentFile[option.value as 'en' | 'vi'] ? (
                                            <div className="flex items-center space-x-4">
                                                <span>{documentFile[option.value as 'en' | 'vi']?.name}</span>
                                                <button
                                                    title="clearDocumentFile"
                                                    onClick={() => setDocumentFile({ ...documentFile, [option.value]: null })}
                                                    className="bg-red-500 !text-white rounded-full p-1 hover:bg-red-600"
                                                >
                                                    <XIcon size={14} />
                                                </button>
                                            </div>
                                        ) : (
                                            <>
                                                <label
                                                    htmlFor={`docFileInput_${option.value}`}
                                                    className="cursor-pointer text-gray-500 hover:text-gray-700"
                                                >
                                                    {documentHasValue[option.value as 'en' | 'vi'] ? 'Change File' : 'Choose File'}
                                                </label>
                                                <input
                                                    type="file"
                                                    id={`docFileInput_${option.value}`}
                                                    accept=".pdf,.doc,.docx"
                                                    onChange={(e) => {
                                                        const file = e.target.files?.[0] || null;
                                                        setDocumentFile({ ...documentFile, [option.value]: file });
                                                    }}
                                                    className="hidden"
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <h3 className="text-xl font-bold mt-2 !mb-0 text-gray-800">Video Guide</h3>
                        <div className="w-full px-4 py-2 bg-white rounded-lg shadow-md mt-2 flex flex-col gap-4">
                            {/* Video Section */}
                            {/* <div className="mb-4">
                                <label className="block text-gray-700 mb-2" htmlFor="difficulty">
                                    Difficulty (Beginner, Intermediate, Advanced)
                                </label>
                                <input
                                    type="text"
                                    id="difficulty"
                                    value={video.difficulty}
                                    onChange={(e) => setVideo({ ...video, difficulty: e.target.value })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded"
                                    placeholder="Enter difficulty"
                                />
                            </div> */}
                            {language_options.map((option, index) => (
                                <div key={option.value} className={`mb-4 ${index === language_options.length - 1 ? '' : 'border-b pb-4'}`}>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 mb-2" htmlFor={`videoUrl_${option.value}`}>
                                            Video URL ({option.lable})
                                        </label>
                                        <input
                                            type="text"
                                            id={`videoUrl_${option.value}`}
                                            value={
                                                video.language.find(lang => lang.name === option.value)?.url || ''
                                            }
                                            onChange={(e) => {
                                                const newLanguages = [...video.language];
                                                const langIndex = newLanguages.findIndex(lang => lang.name === option.value);
                                                if (langIndex !== -1) {
                                                    newLanguages[langIndex] = { ...newLanguages[langIndex], url: e.target.value };
                                                } else {
                                                    newLanguages.push({ name: option.value, icon: '', url: e.target.value });
                                                }
                                                setVideo({ ...video, language: newLanguages });
                                            }}
                                            className="w-full px-3 py-2 border border-gray-300 rounded"
                                            placeholder={`Enter video URL (${option.lable})`}
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 mb-2" htmlFor={`duration_${option.value}`}>
                                            Duration ({option.lable}) (e.g., 10:00)
                                        </label>
                                        <input
                                            type="text"
                                            id={`duration_${option.value}`}
                                            value={video.duration}
                                            onChange={(e) => setVideo({ ...video, duration: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded"
                                            placeholder={`Enter duration (${option.lable})`}
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 mb-2" htmlFor={`videoLanguage_${option.value}`}>
                                            Video Language
                                        </label>
                                        <input
                                            type="text"
                                            id={`videoLanguage_${option.value}`}
                                            value={option.lable}
                                            disabled
                                            className="w-full px-3 py-2 border border-gray-300 rounded bg-gray-100"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <button
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            setViewState('review')
                        }}
                        className="bg-green-500 !text-white px-4 py-2 rounded hover:bg-green-600 mr-2">
                        Preview Store Item
                    </button>
                    <button
                        onClick={handleSubmitData}
                        className="bg-blue-500 !text-white px-4 py-2 rounded hover:bg-blue-600">
                        Save Store Item
                    </button>

                </div>
            </SidebarLayout>
        );
    else if (ViewState === 'review') {
        return (
            <SidebarLayout
                title={
                    <div className="flex items-center gap-2 py-4">
                        <button
                            onClick={() => navigate('/stores')}
                            className="flex items-center justify-center w-7 h-7 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors cursor-pointer"
                        >
                            <ArrowLeftIcon size={16} />
                        </button>
                        <Breadcrumb
                            separator=">"
                            items={[
                                { title: <span className="cursor-pointer" onClick={() => navigate('/stores')}>Stores</span> },
                                { title: `Preview #${id}` },
                            ]}
                        />
                    </div>
                }
            >
                <div className="w-full px-4 py-2 bg-white rounded-lg shadow-md">
                    <div className="w-full grid grid-cols-3 gap-8 mb-4">
                        <div className="col-span-1 flex flex-col ">
                            <h3 className="text-xl font-bold mt-2 !mb-0 text-gray-800"> Missing data: </h3>
                            <div className="w-full border-b-2 border-dashed my-2" />
                            <p className="!mb-0"> Product Card UI </p>
                            <ul className="list-disc list-inside text-red-500">
                                {!imagesSrc && <li>Image</li>}
                                {!itemsName && <li>Store Name</li>}
                                {!itemsPlatform && <li>Platform</li>}
                                {!itemsDescription && <li>Description</li>}
                                {!price && <li>Price</li>}
                            </ul>
                        </div>
                        <div className="w-full col-span-2 max-w-[350px]">
                            <StoreProductCard
                                key={1}
                                id={1}
                                image={imagesFile ? URL.createObjectURL(imagesFile) : imagesSrc}
                                name={itemsName}
                                platform={itemsPlatform}
                                indicator={itemsIndicator}
                                description={itemsDescription.en}
                                price={parseFloat(price).toLocaleString() || '0'}
                                discount={parseFloat(discount).toLocaleString() || '0'}
                                finalPrice={parseFloat(finalPrice).toLocaleString() || '0'}
                                review={0}
                                star={0}
                            />
                        </div>
                    </div>
                </div>
                <div className="w-full mt-4">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Left column  */}
                        <div className="lg:col-span-2 space-y-8">
                            <DetailProductInfo
                                name={itemsName}
                                star={0}
                                review={0}
                                numBuyer={0}
                                description={itemsDescription.en}
                                imgSrc={imagesFile ? URL.createObjectURL(imagesFile) : imagesSrc}
                            />
                            <Tabs
                                defaultActiveKey="1"
                                centered
                                items={[
                                    {
                                        key: '1',
                                        style: { width: '100%' },
                                        label: (
                                            <div className="flex items-center justify-center gap-2 py-1 px-16">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-zap h-5 w-5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                                                Functions and Features
                                            </div>
                                        ),
                                        children: <DetailProductFeature
                                            mainFeature={mainFeature.en}
                                            detail={detail}
                                        />,
                                    },
                                    {
                                        key: '2',
                                        style: { width: '100%' },
                                        label: (
                                            <div className="flex items-center justify-center gap-2 py-1 px-16">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-text h-5 w-5"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
                                                User Guide
                                            </div>
                                        ),
                                        children: <DetailGuildTab
                                            video={video}
                                            document={document}
                                        />,
                                    },
                                ]}
                                style={{
                                    background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                }} />
                        </div>
                        {/* Right column  */}
                        <div className="lg:col-span-1">
                            <div className="sticky top-24 space-y-6">
                                <div className="bg-white rounded-xl shadow-lg p-6">
                                    <div className="text-center mb-6">
                                        <div className="flex items-center justify-center gap-3 mb-2">
                                            <span className="text-3xl font-bold text-gray-900">
                                                {finalPrice} USD
                                            </span>
                                            {
                                                discount && (
                                                    <span className="text-sm text-gray-500 line-through">
                                                        {price}
                                                    </span>
                                                )
                                            }
                                        </div>
                                        <div className="text-sm text-gray-600">One-time purchase, lifetime use</div>
                                        <div className="text-sm text-green-600 font-semibold">Save {discount} %</div>

                                        <button
                                            onClick={() => setIsBuyOpen(true)}
                                            className="w-full cursor-pointer flex items-center justify-center gap-2 bg-blue-600 !text-white px-6 py-3 !rounded-lg hover:bg-blue-700 transition duration-300 font-semibold text-lg mb-4">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-credit-card h-5 w-5"><rect width="20" height="14" x="2" y="5" rx="2"></rect><line x1="2" x2="22" y1="10" y2="10"></line></svg>
                                            Buy now with PayPal
                                        </button>
                                        <Modal
                                            title={
                                                <div className="flex flex-col px-6 pt-4 rounded items-start bg-gradient-to-r from-blue-50 to-indigo-50">
                                                    <h2 className="!text-2xl font-bold text-gray-900 !mb-0">Checkout</h2>
                                                    <p className="text-gray-600">Secure payment via PayPal</p>
                                                </div>
                                            }
                                            styles={{
                                                header: {
                                                    padding: 0,
                                                },
                                                content: {
                                                    padding: 0,
                                                },
                                                body: {
                                                    paddingLeft: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 2,
                                                    paddingTop: 2,
                                                }
                                            }}
                                            style={{
                                                top: 20,
                                            }}
                                            open={isBuyOpen}
                                            onCancel={() => setIsBuyOpen(false)}
                                            footer={null}
                                            width={600}
                                        >
                                            <BuyProductPopUp
                                                id={1}
                                                image={imagesFile ? URL.createObjectURL(imagesFile) : ''}
                                                name={itemsName}
                                                platform={itemsPlatform}
                                                indicator={itemsIndicator}
                                                star={0}
                                                review={0}
                                                description={itemsDescription.en}
                                                price={price}
                                                discount={discount}
                                                finalPrice={finalPrice}
                                            />
                                        </Modal>

                                        <div className="text-xs text-gray-500 text-center mb-4">🔒 100% Secure Payment with PayPal</div>
                                        <div className="space-y-2 text-sm">
                                            <div className="flex items-center gap-2 text-green-600">
                                                <span>✓</span><span>30-day money-back guarantee</span>
                                            </div>
                                            <div className="flex items-center gap-2 text-green-600">
                                                <span>✓</span><span>Lifetime technical support</span>
                                            </div>
                                            <div className="flex items-center gap-2 text-green-600">
                                                <span>✓</span><span>Free updates</span>
                                            </div>
                                            <div className="flex items-center gap-2 text-green-600">
                                                <span>✓</span><span>Comprehensive documentation</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ProductDetailPlatformInfo
                                    code="MT4"
                                    description="Supported Platform"
                                    downloadLink="https://www.metatrader4.com/en/download"
                                    features={['One-click trading', 'Advanced charting tools', 'Expert Advisors (EAs) support']}
                                    icon="https://placehold.co/40x40"
                                    name="MetaTrader 4"
                                    key={1}
                                />
                                <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-6">
                                    <h3 className="font-semibold text-gray-900 mb-2 !text-xl">Need support?</h3>
                                    <p className="text-sm text-gray-600 mb-4">Our team of experts is ready to assist you 24/7</p>
                                    <div className="space-y-2 text-sm">
                                        <div>📧 support@lumir.finance</div>
                                        <div>📱 +84 123 456 789</div>
                                        <div>💬 Live chat on website</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <button
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            setViewState('add')
                        }}
                        className="bg-gray-500 !text-white px-4 py-2 rounded hover:bg-gray-600 mr-2">
                        Back to Edit
                    </button>
                    <button className="bg-blue-500 !text-white px-4 py-2 rounded hover:bg-blue-600">
                        Save Store Item
                    </button>
                </div>
            </SidebarLayout >
        );
    }
    else
        return <div>Loading...</div>
}

export default StoreItems;
